package io.horion.cv.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.models.Country
import io.horion.cv.styles.CountryCardCircleStyle
import io.horion.cv.styles.CountryCardContainerStyle
import io.horion.cv.styles.CountryCardImageStyle
import io.horion.cv.styles.CountryCardTextStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.POPPINS
import io.horion.cv.utils.Constants.UBUNTU
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.px

@Composable
fun CountryCard(
    country: Country,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = CountryCardContainerStyle.toModifier().then(modifier),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(
            modifier = CountryCardCircleStyle.toModifier(),
            contentAlignment = Alignment.Center
        ) {
            Image(
                src = country.image,
                description = "country flag",
                modifier = CountryCardImageStyle.toModifier()
                    .objectFit(ObjectFit.Contain)
            )
        }

        SpanText(
            country.cvname,
            modifier = CountryCardTextStyle.toModifier()
                .fontFamily(POPPINS)
                .color(Colors.DarkBlue)
        )
    }
}